export default "__VITE_ASSET__bc12bdac__"